/* eslint-disable react-hooks/set-state-in-effect */
import { useEffect, useState } from 'react'
import { errorMessage, unwrap } from 'api/call'
import {
  postPremiumTokensCreateTicketForNotActivatedMembership,
  postPremiumTokensMembershipEmail,
  type PremiumToken,
  type PremiumTokenInput,
} from 'api/generated'
import { Button } from 'components/ui/button'
import { Checkbox } from 'components/ui/checkbox'
import { Input } from 'components/ui/input'
import { showSubmittedData } from 'helpers/show-submitted-data'
import { toast } from 'sonner'

export const EditMembershipCodesForm: React.FC<{
  membershipCode?: PremiumToken
  onUpdate?: (id: number, data: PremiumTokenInput) => void
  onCreate?: (data: PremiumTokenInput) => void
  user_id?: number
}> = ({ membershipCode, onUpdate, onCreate, user_id }) => {
  const [id, setId] = useState<number>()
  const [duration, setDuration] = useState('')
  const [consumed, setConsumed] = useState(false)
  const [email, setEmail] = useState('')
  const [userId, setUserId] = useState<number | undefined>(undefined)

  useEffect(() => {
    if (membershipCode) {
      setId(membershipCode.id)
      setConsumed(membershipCode.consumed ?? false)
      setDuration(membershipCode.duration?.toString() ?? '')
      setEmail(membershipCode.email ?? '')
      setUserId(membershipCode.user?.id)
    } else if (user_id !== undefined) {
      setUserId(user_id)
    }
  }, [membershipCode, user_id])

  const isValid = () => duration !== ''

  const handleSave = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    if (onUpdate) {
      if (id) {
        onUpdate(id, {
          duration: Number(duration),
          consumed,
          email,
          user_id: userId,
        })
      }
    } else if (onCreate) {
      onCreate({
        duration: Number(duration),
        consumed,
        email,
        user_id: userId,
      })
    } else {
      toast.error('Impossibile creare codice membership.')
    }
  }

  const handleSendMailAgain = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault()
    if (membershipCode) {
      unwrap(
        postPremiumTokensMembershipEmail({
          query: {
            email: membershipCode.email ?? '',
            id: String(membershipCode.id),
          },
        })
      )
        .then(() => toast.success('Email reinviata con successo'))
        .catch((error) =>
          showSubmittedData(
            errorMessage(error, 'Errore sconosciuto'),
            "Errore durante l'invio della mail"
          )
        )
    }
  }

  const handleCreateBoldeskTicket = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault()
    if (membershipCode) {
      unwrap(
        postPremiumTokensCreateTicketForNotActivatedMembership({
          body: { email: membershipCode.email ?? '' },
        })
      )
        .then(() => toast.success('Ticket Boldesk creato con successo'))
        .catch((error) =>
          showSubmittedData(
            errorMessage(error, 'Errore sconosciuto'),
            'Errore durante la creazione del ticket Boldesk'
          )
        )
    }
  }

  return (
    <form className='flex max-w-xl flex-col gap-4'>
      <p>
        <strong>Duration:</strong>
        <Input
          type='text'
          value={duration}
          onChange={(event) => setDuration(event.target.value)}
        />
      </p>
      <p>
        <strong>Email:</strong>
        <Input
          type='email'
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
      </p>
      <p>
        <strong>User ID:</strong>
        <Input
          type='number'
          value={userId ?? ''}
          onChange={(event) =>
            setUserId(
              event.target.value ? Number(event.target.value) : undefined
            )
          }
        />
      </p>
      <p>
        <strong>Consumed:</strong>
        <Checkbox
          checked={consumed}
          onCheckedChange={() => setConsumed(!consumed)}
        />
      </p>
      <div className='flex flex-row gap-4'>
        <Button onClick={handleSave} disabled={!isValid()}>
          Salva
        </Button>
        {membershipCode && !consumed && (
          <Button onClick={handleSendMailAgain}>Reinvia mail</Button>
        )}
        {membershipCode && !consumed && (
          <Button onClick={handleCreateBoldeskTicket}>
            Crea ticket Boldesk
          </Button>
        )}
      </div>
    </form>
  )
}
